import { MyOptionType, QualityType } from '@procsea/design-system'

export interface Quality {
  name: string
  value: QualityType
}

export const QUALITIES: Quality[] = [
  { value: 'E+', name: gettext('Exceptional') },
  { value: 'E', name: gettext('Extra') },
  { value: 'A+', name: gettext('Good') },
  { value: 'A', name: gettext('Medium') },
  { value: 'B', name: gettext('Low') },
]

export const selectQualityOptions = (): MyOptionType<QualityType>[] =>
  QUALITIES.map(({ name, value }) => ({ label: name, value }))

const useQualityOptions = () => ({ qualityOptions: selectQualityOptions() })

export default useQualityOptions
